/**
 * @file        src/data/rooms.js
 * @description Shared room types with rate options & modal details.
 *              Ported verbatim from /Neon Bookign site Design/.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */

import { GAL } from './gallery.js';

// rooms (shared) — each with rate options + modal detail
export const ROOMS = [
  { name:'Club Twin Room', img:GAL[1], sleeps:2, beds:'1 twin bed', size:'32 m²', pp:1770,
    amen:['Non-smoking','Free Wi-Fi','Air conditioning','Private bathroom'],
    modal:[['Toiletries',['Toothpaste']],['Internet and communications',['Wi-Fi in room — Free','Wired internet in room — Free','Telephone']],['Room layout and furnishings',['Air conditioning','Wardrobe / closet','Sitting area']]],
    rates:[ {perks:['Great breakfast for ₹1,099 (optional)','Non-refundable','Instant confirmation','Pay at hotel'], price:10050, left:2},
            {perks:['Non-refundable','Instant confirmation','Prepay online'], price:10107, left:1} ] },
  { name:'Club King Room', img:GAL[3], sleeps:2, beds:'1 king bed', size:'34 m²', pp:1850,
    amen:['Non-smoking','Free Wi-Fi','Air conditioning','Private bathroom'],
    modal:[['Toiletries',['Toothpaste','Bathrobe','Slippers']],['Internet and communications',['Wi-Fi in room — Free','Wired internet in room — Free','Telephone']],['Room layout and furnishings',['Air conditioning','Wardrobe / closet','Sitting area','Sofa']]],
    rates:[ {perks:['Great breakfast for ₹1,099 (optional)','Non-refundable','Instant confirmation','Pay at hotel'], price:10050, left:2},
            {perks:['Non-refundable','Instant confirmation','Prepay online'], price:10107, left:1} ] },
];
